import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'expenses';

// GET
export const getExpenses = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createExpenses = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateExpenses = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteExpenses = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getExpenses.propTypes = {
  params: PropTypes.object.isRequired,
};

createExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

updateExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteExpenses.propTypes = {
  id: PropTypes.string.isRequired,
};
